import { render, staticRenderFns } from "./PracticeSuccessRequestCancelled.vue?vue&type=template&id=652921be&"
import script from "./PracticeSuccessRequestCancelled.vue?vue&type=script&lang=js&"
export * from "./PracticeSuccessRequestCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports